import { API_URL } from '~/utils';
import { useGet } from '../useGet';

export function useObterFluxos() {
  return useGet({
    url: `${API_URL}/fluxos/obter-fluxos`,
    config: {
      getAccessToken: true,
      timeout: 120000,
    },
  });
}
